module.exports = __webpack_public_path__ + "img/dad-wave.22df0a58.jpg";